"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = __importDefault(require("@gin-betting/core"));
var Subject_1 = require("rxjs/Subject");
var utils_1 = require("../utils");
var getPollerManager = core_1.default.poller.getPollerManager;
var counter = 0;
var isFetched = false;
var subject$ = new Subject_1.Subject();
function usePollingMinStake() {
    var _a = react_1.useState(0), minStake = _a[0], setMinStake = _a[1];
    react_1.useEffect(function () {
        counter += 1;
        var _a = utils_1.getMinBet(), prevMinBet = _a.prevMinBet, request = _a.request;
        if (!prevMinBet && !isFetched) {
            isFetched = true;
            request()
                .then(function (minBet) {
                subject$.next(minBet);
            })
                .catch(function (err) { return console.error(err); });
        }
        setMinStake(prevMinBet);
        var subscription = subject$.subscribe(function (minBet) {
            setMinStake(minBet);
        });
        return function () {
            counter -= 1;
            subscription.unsubscribe();
        };
    }, []);
    return { minStake: minStake };
}
var pollInterval$ = getPollerManager().getIntervalObserve();
pollInterval$.subscribe(function () {
    if (!counter)
        return;
    var request = utils_1.getMinBet().request;
    request()
        .then(function (minBet) {
        subject$.next(minBet);
    })
        .catch(function (err) { return console.error(err); });
});
exports.default = usePollingMinStake;
//# sourceMappingURL=usePollingMinStake.js.map